import styled from "styled-components";

export const SelfieForm = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
  box-shadow: 0 0 11px -1px rgb(229, 229, 229);
  align-items: center;
  margin: 15px 0px;
  padding: 1em;
  #selfie-greetings {
    display: flex;
    flex-direction: column;
    row-gap: 0.15rem;
  }
  .selfie-placeholder {
    margin: 0px auto;
    min-height: 40vh;
  }
  #selfie-form {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    justify-content: center;
    align-items: stretch;
    #selfie-placeholder {
      max-width: 40rem;
    }
    #selfie-img {
      max-height: 32rem;
      max-width: 32rem;
    }
  }
  #selfie-checkfield {
    max-width: 42rem;
    padding: 1rem 1.5rem;
  }
  #selfie-recapture-btn {
    width: 28rem;
    box-shadow: -5px -5px 9px rgb(255 255 255 / 45%),
      3px 3px 14px 0px rgb(94 104 121 / 30%);
    ${"" /* color: #bd2b2b; */}
    padding: 1rem 0px;
  }
  #selfie-submit-btn {
    width: 28rem;
    padding: 1rem 0px;
    ${"" /* background: #bd2b2b; */}
    color: white;
    margin-top: 50px;
  }

  #capture-upload {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    row-gap: 20px;
  }

  #upload-file {
    margin-left: 5em;
    margin-top: 1em;
    display: flex;
    justify-content: center;
  }

  #upload-file::file-selector-button {
    border-radius: 0.5em;
    border: 2px solid lightgrey;
    font-size: 0.85em;
    color: #717171;
  }

  #upload-file::file-selector-button:hover {
    border: 2px solid grey;
    cursor: pointer;
  }

  #proceed-recapture {
    column-gap: 20px;
    align-items: center;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }

  #selfie-submit-btn-2 {
    width: 28rem;
    padding: 1rem 0px;
    background: #bd2b2b;
    color: white;
  }
  .mx-auto {
    margin-left: auto;
    margin-right: auto;
  }
  @media screen and (max-width: 991px) {
    padding: 1.5rem 2.5rem;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    border: none;
    padding: 0;
    box-shadow: none;

    #selfie-img {
      margin-top: 0;
    }

    #selfie-submit-btn {
      width: 100%;
      margin: 0px;
      padding: 1rem 0px;
      margin-bottom: 1.25em;
    }
  }

  .basic-form-title {
    display: flex;
    gap: 0.5em;
    flex-direction: column;
    justify-content: center;
  }

  .title-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: inherit;
  }
`;
